import { useEffect, useState } from "react"

import LookupValue from "./LookupValue"

import { Button } from "web/components"

import { useFieldLookupValues } from "web/hooks/data"
import { useDialogModal, Dialogs } from "web/hooks/modals"

import { sortByKey, isNonEmptyArray } from "web/services/helpers"
import { Label } from "web/components/Form/Controls"

export default function FieldLookupValues({ field, readOnly }) {
  const [optionAdded, setOptionAdded] = useState(null)

  const lookupValues = useFieldLookupValues(field)

  const newValueDialog = useDialogModal(Dialogs.New("option"))
  const dialogModal = useDialogModal()

  // scroll to newly added option
  useEffect(() => {
    if (optionAdded === null) return

    const optionEl = document.getElementById(optionAdded.toLowerCase())
    if (optionEl) {
      optionEl.parentElement.scrollTop =
        optionEl.offsetTop - optionEl.parentNode.offsetTop
      setOptionAdded(null)
    }
  }, [setOptionAdded, optionAdded, lookupValues])

  async function handleAddValue() {
    const result = await newValueDialog()

    if (result) {
      if (!result.response || !result.inputValue) return
      if (
        lookupValues.find(
          (el) => el.label.toLowerCase() === result.inputValue.toLowerCase()
        )
      ) {
        dialogModal({
          title: "Option Already Exists",
          prompt: "An option with that label already exists.",
        })
      } else {
        await lookupValues.add({ label: result.inputValue })
        setOptionAdded(result.inputValue)
      }
    }
  }

  const hasValues = isNonEmptyArray(lookupValues)

  return (
    <div>
      <Label label="Lookup Options" />
      {hasValues && (
        <div
          id="lookup-value-list"
          className="mb-2.5 mt-2.5 grid max-h-40 gap-y-0.5 overflow-y-scroll border border-neutral-8 bg-neutral-10"
        >
          {sortByKey(lookupValues, "label").map((value) => (
            <LookupValue key={value.id} value={value} readOnly={readOnly} />
          ))}
        </div>
      )}
      {!hasValues && (
        <div className="my-2.5 flex items-center justify-center rounded-md bg-neutral-6 p-5 text-white shadow-md">
          There are no options for this field.
        </div>
      )}
      {!readOnly && <Button onClick={handleAddValue}>Add Option</Button>}
    </div>
  )
}
